exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".debug-block[data-v-6e8556e5]{background:#1e1e1e;color:#d4d4d4;padding:10px;border-radius:4px;font-size:12px;white-space:pre-wrap;word-break:break-all}.debug-block.scroll[data-v-6e8556e5]{max-height:250px;overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e8556e5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ReferenceMobile/ReferenceMobileScanDebug.vue
// module id = 901
// module chunks = 0